import { reactive } from 'vue'

/**
 * Store reativo para relatórios prontos aguardando acesso do usuário.
 * Resolve o problema de concorrência quando múltiplos relatórios ficam
 * prontos simultaneamente — todos são enfileirados e exibidos no modal.
 */
const state = reactive({
  reports: [],
})

/**
 * Adiciona um relatório pronto à fila.
 * @param {{ name: string, pdfUrl: string }} report
 */
export function addReadyReport(report) {
  state.reports.push(report)
}

/**
 * Remove um relatório da fila pelo índice.
 * @param {number} index
 */
export function removeReadyReport(index) {
  state.reports.splice(index, 1)
}

/**
 * Limpa todos os relatórios da fila.
 */
export function clearReadyReports() {
  state.reports.splice(0, state.reports.length)
}

/**
 * Retorna o estado reativo (para uso no componente).
 */
export function useReadyReports() {
  return state
}
